import {List, Map} from "immutable";

export function queryToMap(str) {
  let params = new URLSearchParams(str);
  let keys = List(params.keys());
  return keys.reduce((acc, key) => {
    return acc.set(key, params.get(key));
  }, Map())  
}